import { render } from "./DiagramComponentPropsCmp.vue?vue&type=template&id=0f6d5158&scoped=true"
import script from "./DiagramComponentPropsCmp.vue?vue&type=script&lang=js"
export * from "./DiagramComponentPropsCmp.vue?vue&type=script&lang=js"

import "./DiagramComponentPropsCmp.vue?vue&type=style&index=0&id=0f6d5158&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6d5158"]])

export default __exports__